"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberTextMask = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var createNumberMask_1 = tslib_1.__importDefault(require("text-mask-addons/dist/createNumberMask"));
var Base_1 = require("../Base");
exports.NumberTextMask = function (_a) {
    var _b = _a.numberMaskProps, numberMaskProps = _b === void 0 ? {} : _b, rest = tslib_1.__rest(_a, ["numberMaskProps"]);
    var numberMask = react_1.useMemo(function () { return createNumberMask_1.default(numberMaskProps); }, [
        numberMaskProps,
    ]);
    return react_1.default.createElement(Base_1.TextMask, tslib_1.__assign({}, rest, { mask: numberMask }));
};
exports.NumberTextMask.displayName = 'FOS_NumberTextMask';
